export class BaseUrlModel {
  protocol: string;
  url: string;
  paymentServerUrl: string;
  paymentServerPort: string;
  port: number;
  apiVersion: number;
}
